export * from './HighlightedTitle';
